import React from 'react';

import {
  Chart as ChartJS,
  LineController,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { useThemeContext } from '@infoods/lifebase-ui';

ChartJS.register(LineController, LineElement, PointElement, CategoryScale, LinearScale);

type ShortListChartProps = {
  labels: string[][];
  values: number[];
};

const ShortListChart = ({ labels, values }: ShortListChartProps) => {
  const { palette } = useThemeContext();

  return (
    <Line
      data={{ labels, datasets: [{ data: values }] }}
      plugins={[ChartDataLabels]}
      options={{
        events: [],
        animation: false,
        maintainAspectRatio: false,
        elements: {
          line: {
            borderColor: palette.mainBlack,
            borderWidth: 2,
          },
          point: {
            backgroundColor: palette.mainBlack,
          },
        },
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false },
          datalabels: {
            color: palette.mainBlack,
            font: { weight: 700 },
            clamp: true,
            offset: 10,
            align: 'top',
          },
        },
        scales: {
          x: {
            offset: true,
            border: { dash: [3, 3] },
            ticks: {
              color: palette.natural[700],
            },
          },
          y: {
            display: false,
            offset: true,
            grace: 5,
          },
        },
      }}
    />
  );
};

export { ShortListChart };
